export default {
      id: "head-center-usage",
      viewBox: "0 0 26 41",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#head-center",
      toString: function () {
        return this.url;
      }
    }